
import axios from "axios";
import React, { useEffect, useState, useRef, memo, useMemo } from "react";
import { BASE_URL } from "../../config/axios";
import { formatDate, formattedDate, formattedDateLong } from "../Date";
import { DownloadTableExcel } from "react-export-table-to-excel";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { customSortByKey, CustomTooltip, DateRangePicker, handleAllError, handleErrorToast } from "../CustomFunctions";
import { Active, Calender, CircularGrid, DownloadIcon, Employee, Filter, Location, Office, Refresh, Search, SearchBig, Time } from "../AllSvg";
import { AttendanceExtraDetailsTable, AttendanceReguralizationTable } from "../settings/HRActivities/HRActivitiesComponents";
import Select from "react-select";
import { CSSForFilterDropdown } from "../CustomUtilities";
import { useLocation } from "react-router-dom";

const DailyAttendance = () => {
  // *********** Employee Details Api Start ***********
  const [allattendance, setAttendnace] = useState([]);
  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [status_list, setStatus_list] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [subBuffer1, setSubBuffer1] = useState(false); //buffering logic
  const { SUPER_ADMIN, SUB_COMPANIES } = usePermission();

  const [active, setActive] = useState("active");
  const [date, setDate] = useState(`${formattedDate}`);
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company")}`
  );

  const getAllAttendance = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/attendance-bysubcompany-bydate/${toggleCompany}/${active}/${date}/`);

      const companyfiltereddata = res.data.filter((employee) =>
        employee.division_name
          .toLowerCase()
          .includes(selectedDivision.toLowerCase())
      );
      // const sortedList = customSortByKey(res.data, "employee");
      const sortedList = customSortByKey(companyfiltereddata, "employee");

      setAttendnace(sortedList);
      // setAttendnace(res.data);
      const uniqueDayStatus = [
        ...new Set(res.data.map((entry) => entry.day_status)),
      ];
      setStatus_list(uniqueDayStatus);
    } catch (err) {
      handleAllError(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getAllAttendance();
  }, [date, selectedDivision, toggleCompany, active]);
  // *********** Employee Details Api End ***********

  // *********** Filter Logic ***********

  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDayStatus, setSelectedDayStatus] = useState("");
  const [selectedName, setName] = useState("");
  const [selectedSite, setSite] = useState("");


  const applyFilters = () => {
    // Filter employees based on selectedStatus and selectedName
    let filteredData = allattendance;

    if (selectedDayStatus !== "") {
      filteredData = filteredData.filter(
        (employee) => employee.day_status === selectedDayStatus
      );
    }


    if (date === formattedDate) {
      if (selectedStatus === "absent") {
        filteredData = filteredData.filter(
          (employee) => employee.in_time === "00:00:00"
        );
      } else if (selectedStatus === "present") {
        filteredData = filteredData.filter(
          (employee) => employee.in_time !== "00:00:00"
        );
      }
    } else {
      if (selectedStatus !== "") {
        filteredData = filteredData.filter(
          (employee) => employee.attendence_status === selectedStatus
        );
      }
    }

    if (selectedName !== "") {
      // Use includes for a case-insensitive search
      filteredData = filteredData.filter((employee) =>
        employee.name.toLowerCase().includes(selectedName.toLowerCase())
      );
    }
    if (selectedSite !== "") {
      // Use includes for a case-insensitive search
      filteredData = filteredData.filter((employee) =>
        employee.worksite_name
          .toLowerCase()
          .includes(selectedSite.toLowerCase())
      );
    }

    // if (selectedDivision !== "") {
    //   // Use includes for a case-insensitive search
    //   filteredData = filteredData.filter((employee) =>
    //     employee.division_name
    //       .toLowerCase()
    //       .includes(selectedDivision.toLowerCase())
    //   );
    // }
    setFilteredEmployee(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [
    selectedDayStatus,
    selectedStatus,
    selectedName,
    allattendance,
    selectedSite,
    selectedDivision,
  ]);
  const tableRef = useRef(null);

  return (
    <>
      {/* Attendance History Container */}
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading"></div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {SUPER_ADMIN && <div className="field-cont-div">
              {subBuffer1 ? <div className="spinner-vsmall"></div> : <Office />}
              <select
                className="attendance-input-field width-10vw date-field"
                value={toggleCompany}
                onChange={(e) => {
                  const selectedId = e.target.value;

                  if (selectedId === "null") {
                    setToggleCompany("null");
                    setDivision(""); // clear title
                    sessionStorage.setItem("company_id", "null");
                    sessionStorage.setItem("company", "");
                    return;
                  }

                  const selectedCompany = SUB_COMPANIES.find(
                    (c) => String(c.id) === selectedId
                  );

                  setToggleCompany(selectedId); // id
                  setDivision(selectedCompany?.title || ""); // title

                  sessionStorage.setItem("company_id", selectedId);
                  sessionStorage.setItem("company", selectedCompany?.title || "");
                }}
              >
                <option value="null">All Sub Companies</option>
                {SUB_COMPANIES.sort((a, b) => a.title.localeCompare(b.title)).map((i) => (
                  <option key={i.id} value={i.id}>
                    {i.title}
                  </option>
                ))}
              </select>

              <hr className="field-cont-hr" />
            </div>}
            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <input
                className="attendance-input-field width-10vw   date-uppercase"
                placeholder="Date"
                type="date"
                value={date}
                max={formattedDate}
                onChange={(e) => setDate(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title="Day Status" className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDayStatus}
                onChange={(e) => setSelectedDayStatus(e.target.value)}
              >
                <option value="">All Behaviour</option>
                {status_list.map((status) => (
                  <option value={status}>{status}</option>
                ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div title={`${date === formattedDate ? "Office Attendance" : "Attendance Status"}`} className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                {/* <option value="">All Status</option> */}
                <option value="">{date === formattedDate ? "All Office Attendance" : "All Attendance Status"}</option>
                <option value="present">Present</option>
                {date !== formattedDate ? <option value="leave">Leave</option> : null}
                <option value="absent">Absent</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Name"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Location />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Work Site"
                type="text"
                value={selectedSite}
                onChange={(e) => setSite(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>


          </div>

          <div className="btn-cont">
            {/* <button className='attendance-btn' onClick={handleSearch}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 11 12" fill="none">
                <circle cx="5" cy="5" r="4.3" stroke="#FFFFFF" stroke-width="1.4" />
                <line x1="10.0101" y1="11" x2="8" y2="8.98995" stroke="#FFFFFF" stroke-width="1.4" stroke-linecap="round" />
              </svg>Search</button> */}
          </div>
          <DownloadTableExcel
            filename={
              selectedDivision === ""
                ? `DailyAttendanceSheet-${date}`
                : `DailyAttendanceSheet-${date}-${selectedDivision}`
            }
            // filename={`DailyAttendanceSheet-${date}`}
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button className=" model-button-print">
              <DownloadIcon />
            </button>
          </DownloadTableExcel>
        </div>
      </div>

      {/* Attendance History Details */}
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Attendance ( {filteredEmployee.length} of {allattendance.length})
            {/* Attendance ( {filteredEmployee.length} of {subCompanyCount}) */}
          </div>
          <div></div>
        </div>
        <table ref={tableRef} className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr No.</th>
              <th className="align-leftt">Emp Code</th>
              <th className="align-leftt">Name</th>
              <th className="align-leftt">Work Site</th>
              <th className="align-center">Punch In</th>
              <th className="align-center">Punch Out</th>
              <th className="align-center">Total hours</th>
              <th className="align-right">Behaviour</th>
              <th className="align-right">Status</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {filteredEmployee
                .sort((a, b) => {
                  // Extract alphanumeric parts from employee codes
                  const getAlphaNumericParts = (code) => {
                    const match = code.match(/^([A-Za-z]+)(\d+)$/); // Match alphabetic and numeric parts
                    if (match) {
                      return { alphaPart: match[1], numericPart: parseInt(match[2]) };
                    } else {
                      return { alphaPart: '', numericPart: 0 };
                    }
                  };

                  // Extract alpha and numeric parts from employee codes
                  const { alphaPart: alphaA, numericPart: numericA } = getAlphaNumericParts(a.employee);
                  const { alphaPart: alphaB, numericPart: numericB } = getAlphaNumericParts(b.employee);

                  // Compare by alpha part first, then by numeric part if alpha parts are equal
                  if (alphaA !== alphaB) {
                    return alphaA.localeCompare(alphaB); // Sort alphabetically
                  } else {
                    return numericA - numericB; // Then sort numerically
                  }
                })
                .map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left flex-row">
                        {index + 1}
                        {/* {i?.regularization_logs?.length > 0 && (
                          <AttendanceReguralizationTable Ondate={i?.date} AttendanceData={i} RegularizationData={i?.regularization_logs} />
                        )} */}
                        {(i?.regularization_logs?.length > 0 || i?.arrear_details) && (
                          <AttendanceExtraDetailsTable
                            Ondate={i?.date}
                            AttendanceData={i}
                            RegularizationData={i?.regularization_logs?.length > 0 ? i.regularization_logs : undefined}
                            ArrearData={i?.arrear_details || undefined}
                          />
                        )}
                      </td>

                      <td className="align-center">{i.employee}</td>
                      <td className="align-leftt">{i.name}</td>
                      <td className="align-leftt">{i.worksite_name}</td>
                      <td className="align-center">{i.in_time}</td>
                      <td className="align-center">{i.out_time}</td>
                      <td className="align-center">{i.work_duration}</td>

                      <td
                        data-status={i.day_status}
                        className="align-right attendance-status text-capitalize"
                      >
                        {i.day_status}
                      </td>
                      <td
                        data-status={i.attendence_status}
                        className="align-right attendance-status text-capitalize"
                      >
                        {i.attendence_status}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          }
        </table>
      </div>
    </>
  );
};

const EmployeeAttendance = () => {

  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`
  );

  const [active, setActive] = useState("active");

  // *********** Employee Code Api Start ***********
  const [emp_code, setEmp_code] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, SUPER_ADMIN } = usePermission();
  useEffect(() => {
    const getAllEmp_code = async () => {
      setBuffering1(true); //buffering logic // Start Buffering
      try {
        // need sub company version for this
        // const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/`);
        const res = await axios.get(
          PERMISSION_AUTHORITY ?
            `${BASE_URL}/wfm/ourcompanyempdetailsactive/${selectedDivision}/`
            :
            `${BASE_URL}/wfm/ourcompanyempdetailsactive/${selectedDivision}/`
        );
        const sortedList = customSortByKey(res.data, "emp_code");

        setEmp_code(sortedList);
      } catch (err) {
        handleErrorToast(err)
      } finally {
        setBuffering1(false);// End Buffering
      }
    };

    getAllEmp_code();
  }, [active, selectedDivision]);

  // *********** Attendance Get Request Api Start ***********

  const today = new Date();
  today.setDate(today.getDate() - 60);

  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  // const datearrayy = formattedDate.split("-");

  const [allattendance, setAttendance] = useState([]);
  const [status_list, setStatus_list] = useState([]);
  const [startdate, setStartDate] = useState(`${formattedDatee}`);

  const [enddate, setEndDate] = useState(`${formattedDate}`);
  const [selectedEmpcode, setSelectedEmpcode] = useState(
    `${sessionStorage.getItem("emp_code")}`
  );

  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  const getAttendanceDetails = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/attendancefilterbyEmpByMonthstatus/${selectedEmpcode}/${startdate}/${enddate}/`
      );
      // const ress = await axios.get(`${BASE_URL}/wfm/attendancefilterbyEmpByMonthstatusquick/${sessionStorage.getItem("emp_code")}/${startdate}/${enddate}/`)
      setAttendance(res.data);
      const uniqueDayStatus = [
        ...new Set(res.data.map((entry) => entry.day_status)),
      ];

      setStatus_list(uniqueDayStatus);
      // setAttendanceStatus(ress.data)
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getAttendanceDetails();
  }, [startdate, enddate, selectedEmpcode]);



  const applyFilters = () => {
    // Filter employees based on selectedStatus and selectedName
    let filteredData = allattendance;

    if (selectedStatus !== "") {
      filteredData = filteredData.filter(
        (employee) => employee.day_status === selectedStatus
      );
    }

    // if (selectedDivision !== "") {
    //   // Use includes for a case-insensitive search
    //   filteredData = filteredData.filter((employee) =>
    //     employee.division_name
    //       .toLowerCase()
    //       .includes(selectedDivision.toLowerCase())
    //   );
    // }

    if (startdate) {
      filteredData = filteredData.filter(
        (i) => i.date >= startdate
      );
    }
    if (enddate) {
      filteredData = filteredData.filter(
        (i) => i.date <= enddate
      );
    }

    setFilteredEmployee(filteredData);
  };


  useEffect(() => {
    applyFilters();
  }, [selectedStatus, selectedDivision, allattendance, startdate, enddate]);

  const tableRef = useRef(null);

  const emp_options = emp_code
    .filter(option => option.show_attendance === true)
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOptionEmp = { value: 'null', label: 'Select Employee Code' };

  const handleChangeEmpcode = (selectedOption) => {
    if (selectedOption) {
      setSelectedEmpcode(selectedOption.value);
    } else {
      setSelectedEmpcode(null);
    }
  };


  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div title=' Date Range' className="field-cont-div ">
              <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                setStartDate(start || formattedDatee);
                setEndDate(end || formattedDate);
              }} />
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All</option>
                {status_list.map((status) => (
                  <option value={status}>{status}</option>
                ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div title="Employee Filter" className="field-cont-div">
              {buffer1 ?
                <div className="spinner-vsmall" />
                :
                <Employee />
              }
              <Select
                className="attendance-input-field width-20vw"
                options={[nullOptionEmp, ...emp_options]}
                value={emp_options.find(option => option.value === selectedEmpcode) || nullOptionEmp}
                placeholder="Select Employee Code"
                onChange={handleChangeEmpcode}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

          </div>
          <div className="btn-cont">
            {/* <button className='attendance-btn' onClick={getAttendanceDetails}><img src={Searchicon} alt="Search" className='searchicon'/>Search</button> */}
            <DownloadTableExcel
              filename={
                selectedDivision === ""
                  ? `EmployeeAttendanceSheet-${selectedEmpcode}`
                  : `EmployeeAttendanceSheet-${selectedEmpcode}-${selectedDivision}`
              }
              // filename={`EmployeeAttendanceSheet-${selectedEmpcode}`}
              sheet="users"
              currentTableRef={tableRef.current}
            >
              <button className=" model-button-print">
                <DownloadIcon />
                {/* Download as Excel */}
              </button>
            </DownloadTableExcel>
          </div>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Employee Attendance ( {filteredEmployee.length} of{" "}
            {allattendance.length})
          </div>
        </div>
        <table ref={tableRef} className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr No</th>
              <th className="align-center">Date</th>
              <th className="align-center">Punch In</th>
              <th className="align-center">Punch Out</th>
              <th className="align-center">Total hours</th>
              <th className="align-right">Behaviour</th>
              <th className="align-right">Status</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {filteredEmployee
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left flex-row">
                        {index + 1}
                        {/* {i?.regularization_logs?.length > 0 && (
                          <AttendanceReguralizationTable Ondate={i?.date} AttendanceData={i} RegularizationData={i?.regularization_logs} />
                        )} */}
                        {(i?.regularization_logs?.length > 0 || i?.arrear_details) && (
                          <AttendanceExtraDetailsTable
                            Ondate={i?.date}
                            AttendanceData={i}
                            RegularizationData={i?.regularization_logs?.length > 0 ? i.regularization_logs : undefined}
                            ArrearData={i?.arrear_details || undefined}
                          />
                        )}
                      </td>
                      <td className="align-center">
                        {formattedDateLong(i.date)}
                      </td>
                      <td className="align-center">{i.in_time}</td>
                      <td className="align-center">{i.out_time}</td>
                      <td className="align-center">{i.work_duration}</td>

                      <td
                        data-status={i.day_status}
                        className="align-right attendance-status text-capitalize"
                      >
                        {i.day_status}
                      </td>
                      <td
                        data-status={i.attendence_status}
                        className="align-right attendance-status"
                      >
                        {i.attendence_status}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          }
        </table>
      </div>
    </>
  );
};

const SummarySheet = () => {
  const [show, setShow] = useState(false);

  const [indexRow, setIndexRow] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = (e) => {
    setShow(true);
    setIndexRow(e);
  };

  console.log(indexRow);

  const today = new Date();
  // today.setDate(today.getDate() - 1);
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  var datearray = formattedDate.split("-");

  var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];
  console.log(newdate);

  // /attandance/employattandancessheet/222/2/2023/

  const [monthh, setMonthh] = useState(`${month}`);

  const [yearr, setYearr] = useState(`${year}`);
  useEffect(() => {
    getSubCompany();
    getAllattendancedata();
  }, [monthh, yearr]);

  const [allattendance, setAllattendance] = useState([]);

  let getAllattendancedata = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeeattandancessheetall/${monthh}/${yearr}/`
      );
      setAllattendance(res.data);
    } catch (err) {
      alert(err.message);
    }
  };
  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      // alert(err.message);
    }
  };

  const getAllDatesOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const dates = [];
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
      dates.push({ date: formattedDate });
    }

    return dates;
  };

  const dates = getAllDatesOfMonth(monthh, yearr).map((date, index) => ({
    ...date,
    index,
  }));

  const getAllDatessOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
    }

    return datees;
  };

  const datees = getAllDatessOfMonth(monthh, yearr); // get all dates for March 2023

  // *********** Filter Logic ***********
  const [filteredEmployee, setFilteredEmployee] = useState([]);

  // const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company")}`
  );

  const applyFilters = () => {
    // Filter employees based on selectedStatus and selectedName
    let filteredData = allattendance;

    if (selectedStatus !== "") {
      filteredData = filteredData.filter(
        (employee) => employee.employee_status === selectedStatus
      );
    }

    if (selectedName) {
      // Use includes for a case-insensitive search for the name only
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const empCodeMatch = employee.emp_code
          .toString()
          .includes(selectedName);
        return nameMatch || empCodeMatch;
      });
    }

    if (selectedDep) {
      const lowercaseSelectedName = selectedDep.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const depMatch = employee.department_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const rhMatch = employee.rh_name
          ? employee.rh_name.toLowerCase().includes(lowercaseSelectedName)
          : false;

        return depMatch || rhMatch;
      });
    }
    if (selectedDivision !== "") {
      filteredData = filteredData.filter((employee) =>
        employee.division_name
          .toLowerCase()
          .includes(selectedDivision.toLowerCase())
      );
    }

    setFilteredEmployee(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [
    selectedName,
    selectedStatus,
    selectedDep,
    allattendance,
    selectedDivision,
  ]);

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <input
                type="number"
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-10vw   date-field"
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                {/* <option value="">All</option> */}
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Name or Code"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Dep or Rep Head Name"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All</option>

                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>

              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clip-path="url(#clip0_650_3324)">
                  <path
                    d="M2.625 10.2083H1.16667C0.857247 10.2083 0.560501 10.3312 0.341709 10.55C0.122916 10.7688 0 11.0655 0 11.3749L0 12.8333C0 13.1427 0.122916 13.4394 0.341709 13.6582C0.560501 13.877 0.857247 13.9999 1.16667 13.9999H2.625C2.93442 13.9999 3.23117 13.877 3.44996 13.6582C3.66875 13.4394 3.79167 13.1427 3.79167 12.8333V11.3749C3.79167 11.0655 3.66875 10.7688 3.44996 10.55C3.23117 10.3312 2.93442 10.2083 2.625 10.2083ZM2.625 12.8333H1.16667V11.3749H2.625V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 10.2083H11.3749C11.0655 10.2083 10.7688 10.3312 10.55 10.55C10.3312 10.7688 10.2083 11.0655 10.2083 11.3749V12.8333C10.2083 13.1427 10.3312 13.4394 10.55 13.6582C10.7688 13.877 11.0655 13.9999 11.3749 13.9999H12.8333C13.1427 13.9999 13.4394 13.877 13.6582 13.6582C13.877 13.4394 13.9999 13.1427 13.9999 12.8333V11.3749C13.9999 11.0655 13.877 10.7688 13.6582 10.55C13.4394 10.3312 13.1427 10.2083 12.8333 10.2083ZM12.8333 12.8333H11.3749V11.3749H12.8333V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 5.10425H1.16667C0.857247 5.10425 0.560501 5.22716 0.341709 5.44596C0.122916 5.66475 0 5.9615 0 6.27091L0 7.72925C0 8.03867 0.122916 8.33541 0.341709 8.55421C0.560501 8.773 0.857247 8.89592 1.16667 8.89592H2.625C2.93442 8.89592 3.23117 8.773 3.44996 8.55421C3.66875 8.33541 3.79167 8.03867 3.79167 7.72925V6.27091C3.79167 5.9615 3.66875 5.66475 3.44996 5.44596C3.23117 5.22716 2.93442 5.10425 2.625 5.10425ZM2.625 7.72925H1.16667V6.27091H2.625V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 5.10425H11.3749C11.0655 5.10425 10.7688 5.22716 10.55 5.44596C10.3312 5.66475 10.2083 5.9615 10.2083 6.27091V7.72925C10.2083 8.03867 10.3312 8.33541 10.55 8.55421C10.7688 8.773 11.0655 8.89592 11.3749 8.89592H12.8333C13.1427 8.89592 13.4394 8.773 13.6582 8.55421C13.877 8.33541 13.9999 8.03867 13.9999 7.72925V6.27091C13.9999 5.9615 13.877 5.66475 13.6582 5.44596C13.4394 5.22716 13.1427 5.10425 12.8333 5.10425ZM12.8333 7.72925H11.3749V6.27091H12.8333V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M2.625 0H1.16667C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667L0 2.625C0 2.93442 0.122916 3.23117 0.341709 3.44996C0.560501 3.66875 0.857247 3.79167 1.16667 3.79167H2.625C2.93442 3.79167 3.23117 3.66875 3.44996 3.44996C3.66875 3.23117 3.79167 2.93442 3.79167 2.625V1.16667C3.79167 0.857247 3.66875 0.560501 3.44996 0.341709C3.23117 0.122916 2.93442 0 2.625 0ZM2.625 2.625H1.16667V1.16667H2.625V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 10.2083H6.27091C5.9615 10.2083 5.66475 10.3312 5.44596 10.55C5.22716 10.7688 5.10425 11.0655 5.10425 11.3749V12.8333C5.10425 13.1427 5.22716 13.4394 5.44596 13.6582C5.66475 13.877 5.9615 13.9999 6.27091 13.9999H7.72925C8.03867 13.9999 8.33541 13.877 8.55421 13.6582C8.773 13.4394 8.89592 13.1427 8.89592 12.8333V11.3749C8.89592 11.0655 8.773 10.7688 8.55421 10.55C8.33541 10.3312 8.03867 10.2083 7.72925 10.2083ZM7.72925 12.8333H6.27091V11.3749H7.72925V12.8333Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 5.10425H6.27091C5.9615 5.10425 5.66475 5.22716 5.44596 5.44596C5.22716 5.66475 5.10425 5.9615 5.10425 6.27091V7.72925C5.10425 8.03867 5.22716 8.33541 5.44596 8.55421C5.66475 8.773 5.9615 8.89592 6.27091 8.89592H7.72925C8.03867 8.89592 8.33541 8.773 8.55421 8.55421C8.773 8.33541 8.89592 8.03867 8.89592 7.72925V6.27091C8.89592 5.9615 8.773 5.66475 8.55421 5.44596C8.33541 5.22716 8.03867 5.10425 7.72925 5.10425ZM7.72925 7.72925H6.27091V6.27091H7.72925V7.72925Z"
                    fill="#707070"
                  />
                  <path
                    d="M7.72925 0H6.27091C5.9615 0 5.66475 0.122916 5.44596 0.341709C5.22716 0.560501 5.10425 0.857247 5.10425 1.16667V2.625C5.10425 2.93442 5.22716 3.23117 5.44596 3.44996C5.66475 3.66875 5.9615 3.79167 6.27091 3.79167H7.72925C8.03867 3.79167 8.33541 3.66875 8.55421 3.44996C8.773 3.23117 8.89592 2.93442 8.89592 2.625V1.16667C8.89592 0.857247 8.773 0.560501 8.55421 0.341709C8.33541 0.122916 8.03867 0 7.72925 0ZM7.72925 2.625H6.27091V1.16667H7.72925V2.625Z"
                    fill="#707070"
                  />
                  <path
                    d="M12.8333 0H11.3749C11.0655 0 10.7688 0.122916 10.55 0.341709C10.3312 0.560501 10.2083 0.857247 10.2083 1.16667V2.625C10.2083 2.93442 10.3312 3.23117 10.55 3.44996C10.7688 3.66875 11.0655 3.79167 11.3749 3.79167H12.8333C13.1427 3.79167 13.4394 3.66875 13.6582 3.44996C13.877 3.23117 13.9999 2.93442 13.9999 2.625V1.16667C13.9999 0.857247 13.877 0.560501 13.6582 0.341709C13.4394 0.122916 13.1427 0 12.8333 0ZM12.8333 2.625H11.3749V1.16667H12.8333V2.625Z"
                    fill="#707070"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_650_3324">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value=""> All Sub Companies</option>
                {SubCompany.sort((a, b) => a.title - b.title).map((i, index) => (
                  <option value={i.title}>{i.title}</option>
                ))}
                ;
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="custom-table-container">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            Attendance ( {filteredEmployee.length} of {allattendance.length})
          </div>
          <div></div>
        </div>

        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr No. </th>
              <th className="align-left">Emp Code</th>
              <th className="align-leftt">Name</th>
              <th className="align-left">Joining Date</th>
              <th className="align-left">Total Days</th>
              <th className="align-left">LB</th>
              <th className="align-left">Pres.</th>
              <th className="align-left">Abse.</th>
              <th className="align-left">RLM</th>
              <th className="align-left">Late</th>
              <th className="align-left">Ont.</th>
              <th className="align-left">HD</th>
              <th className="align-left">WO</th>
              <th className="align-left">WOP</th>
              <th className="align-left">Hols</th>
              <th className="align-left">OD.</th>
              <th className="align-left">HD. OD.</th>
              <th className="align-left">SD. OD.</th>
              <th className="align-left">PL.</th>
              <th className="align-left">HD. L.</th>
              <th className="align-left">SD. L.</th>
              <th className="align-left">UL.</th>
              <th className="align-left">Hd. UL.</th>
              <th className="align-left">Sd. UL.</th>

              {/* <th className="align-left">Status</th> */}
            </tr>
          </thead>
          <tbody>
            {filteredEmployee
              .sort((a, b) => a.emp_code - b.emp_code)
              .map((data, index) => {
                let total_style = dates.length;

                return (
                  <>
                    <tr className="custom-table-head-tdd">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-left">{data.emp_code}</td>
                      <td className="align-leftt">{data?.name}</td>
                      <td className="align-left">
                        {formatDate(data.joining_date)}
                      </td>

                      {/* {show ? <td className="align-left" onClick={handleClose(index+1)}>{data.total_days ? data.total_days : "-"}</td>  : <td className="align-left" onClick={handleShow(index+1)}>{data.total_days ? data.total_days : "-"}</td>} */}

                      {show ? (
                        <td
                          className="align-left"
                          onClick={() => handleClose(index + 1)}
                          style={{
                            color: total_style > data.total ? "red" : "",
                          }}
                        >
                          {data.total ? data.total : "-"}
                        </td>
                      ) : (
                        <td
                          className="align-left"
                          onClick={() => handleShow(index + 1)}
                          style={{
                            color: total_style > data.total ? "red" : "",
                          }}
                        >
                          {data.total ? data.total : "-"}
                        </td>
                      )}

                      {/* 
                      <td className="align-left" onClick={handleShow}>{data.total_days ? data.total_days : "-"}</td> */}
                      <td className="align-left">{data.leavebalance}</td>
                      <td className="align-left">{data.present}</td>
                      <td className="align-left">{data.absent}</td>
                      <td className="align-left">{data.rlm}</td>
                      <td className="align-left">{data.late}</td>
                      <td className="align-left">{data.ontime}</td>
                      <td className="align-left">{data.halfday}</td>
                      <td className="align-left">{data.weeklyoff}</td>
                      <td className="align-left">{data.wop}</td>
                      <td className="align-left">{data.holiday}</td>
                      <td className="align-left">{data.outduty}</td>
                      <td className="align-left">{data.hdoutduty}</td>
                      <td className="align-left">{data.shortoutduty}</td>
                      <td className="align-left">{data.leave}</td>
                      <td className="align-left">{data.halfdayleave}</td>
                      <td className="align-left">{data.shortleave}</td>
                      <td className="align-left">{data.unpaidleave}</td>
                      <td className="align-left">{data.unpaidleavehd}</td>
                      <td className="align-left">{data.unpaidshortleave}</td>
                    </tr>
                    {show === true && index + 1 === indexRow ? (
                      <tr>
                        <td colSpan="28">
                          <table className="custom-table-subtable">
                            <tr className="custom-table-head-tdd">
                              {datees.map((date) => (
                                <td
                                  className="summarysheet-heading-circle"
                                  key={date.date}
                                >
                                  {date.date}
                                </td>
                              ))}
                            </tr>

                            <tr className="custom-table-head-tdd">
                              {dates.map((date) => {
                                const attendanceForDate = data.attendances.find(
                                  (attendance) => attendance.date === date.date
                                );
                                const attendanceStatus = attendanceForDate
                                  ? attendanceForDate.day_status
                                  : "-";

                                const attendanceStatuss = attendanceForDate
                                  ? attendanceForDate.day_status === "ontime"
                                    ? "P"
                                    : attendanceForDate.day_status === "outduty"
                                      ? "OD"
                                      : attendanceForDate.day_status === "halfday"
                                        ? "HD"
                                        : attendanceForDate.day_status ===
                                          "paidleave"
                                          ? "PL"
                                          : attendanceForDate.day_status === "late"
                                            ? "Late"
                                            : attendanceForDate.day_status ===
                                              "weeklyoff"
                                              ? "WO"
                                              : attendanceForDate.day_status === "wop"
                                                ? "WOP"
                                                : attendanceForDate.day_status === "rlm"
                                                  ? "RLM"
                                                  : attendanceForDate.day_status ===
                                                    "halfdayleave"
                                                    ? "HDL"
                                                    : attendanceForDate.day_status ===
                                                      "unpaidleave"
                                                      ? "UL"
                                                      : attendanceForDate.day_status ===
                                                        "shortleave"
                                                        ? "SL"
                                                        : attendanceForDate.day_status ===
                                                          "unpaidshortleave"
                                                          ? "USL"
                                                          : attendanceForDate.day_status ===
                                                            "unpaidleavehd"
                                                            ? "UHD"
                                                            : attendanceForDate.day_status ===
                                                              "hdoutduty"
                                                              ? "HOD"
                                                              : attendanceForDate.day_status ===
                                                                "shortoutduty"
                                                                ? "SOD"
                                                                : attendanceForDate.day_status ===
                                                                  "misspunch"
                                                                  ? "Miss"
                                                                  : attendanceForDate.day_status === "holiday"
                                                                    ? "Hol"
                                                                    : attendanceForDate.day_status === "absent"
                                                                      ? "A"
                                                                      : attendanceForDate.day_status.slice(0, 2)
                                  : "-";

                                // // Example usage:
                                // <span>{attendanceStatus}</span>
                                // {attendanceStatuss.slice(0, 2).toUpperCase()}

                                // const attendanceStatusCircle = attendanceForDate
                                //   ? attendanceForDate.attendence_status === "present"
                                //     ? "color-tab-green"
                                //     : attendanceForDate.day_status === "absent"
                                //       ? "color-tab-red"
                                //       : "summarysheet-circle-default" : '';

                                const inTime = attendanceForDate
                                  ? attendanceForDate.in_time
                                  : "-";
                                const outTime = attendanceForDate
                                  ? attendanceForDate.out_time
                                  : "-";
                                const attstat = attendanceForDate
                                  ? attendanceForDate.attendence_status
                                  : "-";
                                const daystatus = attendanceForDate
                                  ? attendanceForDate.day_status
                                  : "-";

                                return (
                                  // <>
                                  <td
                                    className="summarysheet-heading-circle behavior"
                                    data-status={attendanceStatus}
                                    title={`In Time: ${inTime}\nOut Time: ${outTime}\nAttendance Status: ${attstat}\nDay Status: ${daystatus}`}
                                  >
                                    {attendanceStatuss}
                                  </td>
                                );
                              })}
                            </tr>
                          </table>
                        </td>{" "}
                      </tr>
                    ) : (
                      ""
                    )}{" "}
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

// Memoized Row Component

// 1. Ultra-fast lookup map for attendance abbreviations (replaces the 20 nested ternaries)
const STATUS_MAP = {
  ontime: "P",
  outduty: "OD",
  halfday: "HD",
  paidleave: "PL",
  late: "Late",
  weeklyoff: "WO",
  wop: "WOP",
  rlm: "RLM",
  halfdayleave: "HDL",
  paidhalfdayleave: "PHDL",
  unpaidleave: "UL",
  shortleave: "SL",
  unpaidshortleave: "USL",
  unpaidleavehd: "UHD",
  hdoutduty: "HOD",
  shortoutduty: "SOD",
  misspunch: "Miss",
  holiday: "Hol",
  absent: "A",
};

const EmployeeRow = memo(({ 
  data, 
  dates, 
  isSelected, 
  index,
  onClick, 
  formatDate, 
  formattedDateLong 
}) => {
  // Summary column background colors
  const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
  const present = data.present === 0 ? "white" : "#a3fc92";
  const ontime = data.ontime === 0 ? "white" : "#a3fc92";
  const late = data.late === 0 ? "white" : "#ffea72";
  const rlm = data.rlm === 0 ? "white" : "#a3fc92";
  const halfday = data.halfday === 0 ? "white" : "#ffea72";
  const wop = data.wop === 0 ? "white" : "#a3fc92";
  const od = data.outduty === 0 ? "white" : "#73DBDBCC";
  const bgabsent = data.absent === 0 ? "white" : "#fccab1";
  const holiday = data.holiday === 0 ? "white" : "#83B8E6CC";
  const weeklyoff = data.weeklyoff === 0 ? "white" : "#83B8E6CC";
  const leave = data.leave === 0 ? "white" : "#a3fc92";
  const halfdayleave = data.halfdayleave === 0 ? "white" : "#a3fc92";
  const shortleave = data.shortleave === 0 ? "white" : "#a3fc92";
  const workfromhome = data.workfromhome === 0 ? "white" : "#a3fc92";
  const hdoutduty = data.hdoutduty === 0 ? "white" : "#73DBDBCC";
  const shortoutduty = data.shortoutduty === 0 ? "white" : "#73DBDBCC";
  const unpaidleave = data.unpaidleave === 0 ? "white" : "#fccab1";
  const unpaidleavehd = data.unpaidleavehd === 0 ? "white" : "#fccab1";
  const unpaidshortleave = data.unpaidshortleave === 0 ? "white" : "#fccab1";
  const misspunch = data.misspunch === 0 ? "white" : "#fccab1";
  const bgtotalpaiddays = data.total === dates.length ? "white" : "#fccab1";

  const handleRowClick = () => {
    onClick(index);
  };

  // Leave balance tooltip formatting
  const leaveBalanceTooltip = `Previous: ${data?.leavebalance || 0}\nCasual: ${data?.casual_leave || 0}\nSick: ${data?.sick_leave || 0}\nEarn: ${data?.earn_leave || 0}\nShort: ${data?.short_leave || 0}`;
  const totalLeaves = (data?.leavebalance || 0) + (data?.casual_leave || 0) + (data?.sick_leave || 0) + (data?.earn_leave || 0);

  return (
    <tr
      style={{
        backgroundColor: isSelected ? "yellow" : "white",
        color: inactivename,
      }}
      onClick={handleRowClick}
    >
      <td className="summary-excel-tab br-5">{data.emp_code}</td>
      <td className="summary-excel-tab br-5">{data.name}</td>
      <td
        className="summary-excel-tab br-5"
        title={data.last_working_date ? `Last Working Date - ${formatDate(data.last_working_date)}` : ""}
      >
        {formatDate(data.joining_date)}
      </td>

      {/* Render Dynamic Dates */}
      {dates.map((dateObj) => {
        // INSTANT LOOKUP (Requires the attendanceMap we created in useMemo)
        const attendanceForDate = data.attendanceMap ? data.attendanceMap[dateObj.date] : null;

        const daystatus = attendanceForDate ? attendanceForDate.day_status : "-";
        const attstat = attendanceForDate ? attendanceForDate.attendence_status : "-";
        const inTime = attendanceForDate?.in_time || "-";
        const outTime = attendanceForDate?.out_time || "-";
        const duration = attendanceForDate?.work_duration || "-";

        // Map status to abbreviation
        const attendanceStatuss = attendanceForDate 
            ? (STATUS_MAP[daystatus] || daystatus.slice(0, 2)) 
            : "-";

        // Determine if employee was active on this date
        const isActiveOnDate = dateObj.date >= data.joining_date && (!data.last_working_date || dateObj.date <= data.last_working_date);
        
        // Build Native Tooltip String
        let cellTooltip = `Date: ${formattedDateLong ? formattedDateLong(dateObj.date) : dateObj.date}\nIn Time: ${inTime}\nOut Time: ${outTime}\nDay Status: ${daystatus}\nAttendance Status: ${attstat}\nWork Duration: ${duration}`;

        if (attendanceForDate?.regularization_logs?.length > 0) {
          const latestLog = [...attendanceForDate.regularization_logs].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
          cellTooltip += `\n\nRegularization Reason:\n- ${latestLog.reason}`;
        }

        if (attendanceForDate?.arrear_details) {
          if (attendanceForDate.arrear_details.length === 1) {
            cellTooltip += `\n\nThis date Arreared in ${attendanceForDate.arrear_details[0].applicable_period}`;
          } else if (attendanceForDate.arrear_details.length > 1) {
            cellTooltip += `\n\nThis date used in multiple Arrears`;
          }
        }

        return (
          <td
            key={dateObj.fullDate || dateObj.date}
            className="summary-excel-tab br-5 behavior"
            style={{
              backgroundColor: isSelected ? "yellow" : dateObj.isDisabled ? "#f0f0f0" : "",
              color: isSelected ? "black" : dateObj.isDisabled ? "#3f3d3d" : "",
              opacity: dateObj.isDisabled ? 0.9 : 1,
              position: "relative",
            }}
            data-status={isActiveOnDate ? daystatus : "-"}
            title={cellTooltip}
          >
            {isActiveOnDate ? attendanceStatuss : "-"}

            {/* Indicator Dot for Regularization/Arrears */}
            {(attendanceForDate?.regularization_logs?.length > 0 || attendanceForDate?.arrear_details) && (
              <span
                style={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  fontSize: "5px",
                  color: "white",
                  width: "6px",
                  height: "6px",
                  borderRadius: "100%",
                  backgroundColor: "#2576BC",
                  cursor: "pointer",
                  textAlign: "center",
                }}
              >
                i
              </span>
            )}
          </td>
        );
      })}

      {/* Render Summary Totals */}
      <td className="summary-excel-tab br-5" title={leaveBalanceTooltip}>
        {totalLeaves}
      </td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: present }}>{data.present}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: ontime }}>{data.ontime}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: late }}>{data.late}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: rlm }}>{data.rlm}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: halfday }}>{data.halfday}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: wop }}>{data.wop}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: od }}>{data.outduty}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: bgabsent }}>{data.absent}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: holiday }}>{data.holiday}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: weeklyoff }}>{data.weeklyoff}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: leave }}>{data.leave}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: halfdayleave }}>{data.halfdayleave}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: shortleave }}>{data.shortleave}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: workfromhome }}>{data.workfromhome}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: hdoutduty }}>{data.hdoutduty}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: shortoutduty }}>{data.shortoutduty}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: unpaidleave }}>{data.unpaidleave}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: unpaidleavehd }}>{data.unpaidleavehd}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: unpaidshortleave }}>{data.unpaidshortleave}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: misspunch }}>{data.misspunch}</td>
      <td className="summary-excel-tab br-5" style={{ backgroundColor: bgtotalpaiddays }}>{data.total}</td>
    </tr>
  );
});


const SummarySheetExcel = () => {

  const { SUPER_ADMIN, SUB_COMPANIES } = usePermission();

  const location = useLocation();

  const realToday = new Date();
  const currentMonth = (realToday.getMonth() + 1).toString();
  const currentYear = realToday.getFullYear().toString();

  // 2. If you still need "yesterday" for your 'day' variable, calculate it separately!
  // const yesterday = new Date();
  // yesterday.setDate(yesterday.getDate() - 1);
  // const day = yesterday.getDate();

  // 3. Initialize your states using the REAL current month
  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);

  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  // This is what the Auto-Forwarding logic will use
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const todayFull = `${realToday.getFullYear()}-${(realToday.getMonth() + 1).toString().padStart(2, "0")}-${realToday.getDate().toString().padStart(2, "0")}`;

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  const [payrollStartDate, setPayrollStartDate] = useState(null);
  const [payrollEndDate, setPayrollEndDate] = useState(null);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthName = monthNames[startMonth - 1];

  // const formattedDate = `${currentYear}-${currentMonth.toString().padStart(2, "0")}-${day
  //   .toString()
  //   .padStart(2, "0")}`;
    
  // var datearray = formattedDate.split("-");
  // var newdate = datearray[0] + "-" + datearray[1] + "-" + datearray[2];
  const [allattendance, setAllattendance] = useState([]);
  const [subbuffer, setSubBuffering] = useState(false); //buffering logic
  const [buffer, setBuffering] = useState(false); //buffering logic
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company")}`
  );
  const [toggleCompany, setToggleCompany] = useState(`${sessionStorage.getItem("company_id") || "null"}`);

  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("active");


  // let getAllattendancedata = async () => {
  //   setBuffering(true); //buffering logic
  //   try {
  //     const res = await axios.get(
  //       // `${BASE_URL}/wfm/optimized-attandances-sheet-bysubcompany/${toggleCompany}/${selectedStatus}/${startYear}/${startMonth}/`
  //       `${BASE_URL}/wfm/optimized-attandances-sheet-bysubcompany/v2/${toggleCompany}/${selectedStatus}/${startYear}/${startMonth}/`
  //     );
  //     const sortedData = customSortByKey(res.data, "emp_code");
  //     setAllattendance(sortedData);
  //     // setAllattendance(res.data);
  //   } catch (err) {
  //     handleAllError(err)
  //   } finally {
  //     setBuffering(false); //buffering logic
  //   }
  // };

  // let getAllattendancedata = async () => {
  //   setBuffering(true);
  //   try {
  //     const res = await axios.get(
  //       // `${BASE_URL}/wfm/optimized-attandances-sheet-bysubcompany/v2/${toggleCompany}/${selectedStatus}/${startYear}/${startMonth}/`
  //       `${BASE_URL}/wfm/optimized-attandances-sheet-bysubcompany/v2_2/${toggleCompany}/${selectedStatus}/${startYear}/${startMonth}/`
  //     );


  //     const { results, payroll_start_date, payroll_end_date } = res.data;

  //     const sortedData = customSortByKey(results, "emp_code");
  //     setAllattendance(sortedData);
  //     setPayrollStartDate(payroll_start_date);
  //     setPayrollEndDate(payroll_end_date);
  //   } catch (err) {
  //     handleAllError(err);
  //   } finally {
  //     setBuffering(false);
  //   }
  // };

  let getAllattendancedata = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/optimized-attandances-sheet-bysubcompany/v2_2/${toggleCompany}/${selectedStatus}/${startYear}/${startMonth}/`
      );

      const { results, payroll_start_date, payroll_end_date } = res.data;

      // ── Auto-Forwarding Logic ──────────────────────────────────────────────
      if (isInitialLoad && payroll_end_date && todayFull > payroll_end_date) {
        setIsInitialLoad(false); // Prevent loop

        // Calculate next month
        let nextM = parseInt(startMonth) + 1;
        let nextY = parseInt(startYear);
        if (nextM > 12) {
          nextM = 1;
          nextY++;
        }

        const nextMonthStr = nextM.toString().padStart(2, "0");
        const nextYearStr = nextY.toString();

        // Update the states (this will automatically trigger your useEffect)
        setStartMonth(nextMonthStr);
        setStartYear(nextYearStr);
        
        // Keep the end month/year in sync if your UI uses them
        setEndMonth(nextMonthStr);
        setEndYear(nextYearStr);

        return; // Exit early to avoid setting the old month's data
      }
      // ───────────────────────────────────────────────────────────────────────

      setIsInitialLoad(false); // Mark initial load as complete for normal cycles
      const sortedData = customSortByKey(results, "emp_code");
      setAllattendance(sortedData);
      setPayrollStartDate(payroll_start_date);
      setPayrollEndDate(payroll_end_date);
      
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false);
    }
  };

  // const getAllDatesOfMonth = (month, year) => {
  //   const numberOfDaysInMonth = new Date(year, month, 0).getDate();
  //   const dates = [];
  //   const datees = [];

  //   for (let i = 1; i <= numberOfDaysInMonth; i++) {
  //     const date = new Date(year, month - 1, i);
  //     const day = date.getDate();
  //     const formatttedDatee = `${day.toString().padStart(2, "0")}`;
  //     datees.push({ date: formatttedDatee });
  //     const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
  //       .toString()
  //       .padStart(2, "0")}`;
  //     dates.push({ date: formattedDate });
  //   }

  //   return dates;
  // };

  // const dates = getAllDatesOfMonth(startMonth, startYear).map((date, index) => ({
  //   ...date,
  //   index,
  // }));

  // const dates = getAllDatesOfMonth(startMonth, startYear)
  //   .filter((date) => {
  //     if (!payrollEndDate) return true; // show all if not available
  //     return date.date <= payrollEndDate;
  //   })
  //   .map((date, index) => ({
  //     ...date,
  //     index,
  //   }));

  // const getPayrollDates = (payrollStart, payrollEnd, month, year) => {
  //   const monthPadded = String(month).padStart(2, "0");

  //   const startStr = payrollStart || `${year}-${monthPadded}-01`;
  //   const endStr = payrollEnd || (() => {
  //     const lastDay = new Date(year, month, 0).getDate();
  //     return `${year}-${monthPadded}-${lastDay}`;
  //   })();

  //   //  Always iterate full calendar month
  //   const fullMonthStart = new Date(year, month - 1, 1);
  //   const fullMonthEnd = new Date(year, month, 0); // last day of month

  //   const fullDates = [];
  //   const displayDates = [];

  //   const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  //     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  //   let current = new Date(fullMonthStart);
  //   while (current <= fullMonthEnd) {
  //     const yyyy = current.getFullYear();
  //     const mm = String(current.getMonth() + 1).padStart(2, "0");
  //     const dd = String(current.getDate()).padStart(2, "0");
  //     const fullDate = `${yyyy}-${mm}-${dd}`;

  //     // ✅ Mark dates beyond payrollEndDate as disabled
  //     const isDisabled = fullDate > endStr;

  //     fullDates.push({ date: fullDate, isDisabled });
  //     displayDates.push({
  //       date: dd,
  //       month: monthNames[current.getMonth()],
  //       fullDate,
  //       isDisabled,
  //     });

  //     current.setDate(current.getDate() + 1);
  //   }

  //   return { fullDates, displayDates };
  // };

  const getPayrollDates = (payrollStart, payrollEnd, month, year) => {
    const monthPadded = String(month).padStart(2, "0");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const endStr = payrollEnd || (() => {
      const lastDay = new Date(year, month, 0).getDate();
      return `${year}-${monthPadded}-${lastDay}`;
    })();

    const startStr = payrollStart || `${year}-${monthPadded}-01`;

    // ── Check if it's a cross-month 25–24 cycle ──────────────────────────────
    // Cross-month = payrollStart month != payrollEnd month
    const isCrossMonth = payrollStart && payrollEnd &&
      payrollStart.substring(0, 7) !== payrollEnd.substring(0, 7);

    const fullDates = [];
    const displayDates = [];

    if (isCrossMonth) {
      // ── Cross-month cycle (e.g. 25 May → 24 June) ────────────────────────
      // Show BOTH months fully, disable dates outside payroll window
      const start = new Date(startStr);   // 2026-05-25
      const end = new Date(endStr);       // 2026-06-24

      // Prev month: 1st of payrollStart month → last day of payrollStart month
      const prevMonthStart = new Date(start.getFullYear(), start.getMonth(), 1);
      const prevMonthEnd = new Date(start.getFullYear(), start.getMonth() + 1, 0);

      // Curr month: 1st of payrollEnd month → last day of payrollEnd month
      const currMonthStart = new Date(end.getFullYear(), end.getMonth(), 1);
      const currMonthEnd = new Date(end.getFullYear(), end.getMonth() + 1, 0);

      // Iterate prev month (e.g. all of May)
      let cur = new Date(prevMonthStart);
      while (cur <= prevMonthEnd) {
        const yyyy = cur.getFullYear();
        const mm = String(cur.getMonth() + 1).padStart(2, "0");
        const dd = String(cur.getDate()).padStart(2, "0");
        const fullDate = `${yyyy}-${mm}-${dd}`;
        const isDisabled = fullDate < startStr; // before 25 May → disabled

        fullDates.push({ date: fullDate, isDisabled });
        displayDates.push({
          date: dd,
          month: monthNames[cur.getMonth()],
          fullDate,
          isDisabled,
        });
        cur.setDate(cur.getDate() + 1);
      }

      // Iterate curr month (e.g. all of June)
      cur = new Date(currMonthStart);
      while (cur <= currMonthEnd) {
        const yyyy = cur.getFullYear();
        const mm = String(cur.getMonth() + 1).padStart(2, "0");
        const dd = String(cur.getDate()).padStart(2, "0");
        const fullDate = `${yyyy}-${mm}-${dd}`;
        const isDisabled = fullDate > endStr; // after 24 June → disabled

        fullDates.push({ date: fullDate, isDisabled });
        displayDates.push({
          date: dd,
          month: monthNames[cur.getMonth()],
          fullDate,
          isDisabled,
        });
        cur.setDate(cur.getDate() + 1);
      }

    } else {
      // ── Same-month cycle (e.g. 1 May → 24 May, or older months) ─────────
      // Show full calendar month, disable dates beyond payrollEnd
      const fullMonthStart = new Date(year, month - 1, 1);
      const fullMonthEnd = new Date(year, month, 0);

      let cur = new Date(fullMonthStart);
      while (cur <= fullMonthEnd) {
        const yyyy = cur.getFullYear();
        const mm = String(cur.getMonth() + 1).padStart(2, "0");
        const dd = String(cur.getDate()).padStart(2, "0");
        const fullDate = `${yyyy}-${mm}-${dd}`;
        const isDisabled = fullDate > endStr;

        fullDates.push({ date: fullDate, isDisabled });
        displayDates.push({
          date: dd,
          month: monthNames[cur.getMonth()],
          fullDate,
          isDisabled,
        });
        cur.setDate(cur.getDate() + 1);
      }
    }

    return { fullDates, displayDates };
  };

  //  Replace existing dates and datees
 const { fullDates: dates, displayDates: datees } = useMemo(() => {
  return getPayrollDates(
    payrollStartDate,
    payrollEndDate,
    startMonth,
    startYear
  );
}, [payrollStartDate, payrollEndDate, startMonth, startYear]);

  const getAllDatessOfMonth = (month, year) => {
    const numberOfDaysInMonth = new Date(year, month, 0).getDate();
    const datees = [];

    for (let i = 1; i <= numberOfDaysInMonth; i++) {
      const date = new Date(year, month - 1, i);
      const day = date.getDate();
      const formatttedDatee = `${day.toString().padStart(2, "0")}`;
      datees.push({ date: formatttedDatee });
    }

    return datees;
  };

  // const datees = getAllDatessOfMonth(startMonth, startYear); // get all dates for March 2023
  // const datees = getAllDatessOfMonth(startMonth, startYear).filter((dateObj) => {
  //   if (!payrollEndDate) return true;
  //   const fullDate = `${startYear}-${startMonth.toString().padStart(2, "0")}-${dateObj.date}`;
  //   return fullDate <= payrollEndDate;
  // });

  const refreshdata = async () => {
    setBuffering(true); //buffering logic
    await getAllattendancedata();
    setBuffering(false); //buffering logic
  };

  useEffect(() => {
    getAllattendancedata();
  }, [startMonth, startYear, monthName, toggleCompany, selectedStatus]);

  // *********** Filter Logic ***********
  const [filteredEmployee, setFilteredEmployee] = useState([]);

  // const applyFilters = () => {
  //   let filteredData = allattendance;

  //   if (selectedName) {
  //     // Use includes for a case-insensitive search for the name only
  //     const lowercaseSelectedName = selectedName.toLowerCase();
  //     filteredData = filteredData.filter((employee) => {
  //       const nameMatch = employee.name
  //         .toLowerCase()
  //         .includes(lowercaseSelectedName);
  //       const empCodeMatch = employee.emp_code
  //         .toString()
  //         .includes(selectedName);
  //       return nameMatch || empCodeMatch;
  //     });
  //   }

  //   if (selectedDep) {
  //     const lowercaseSelectedName = selectedDep.toLowerCase();

  //     filteredData = filteredData.filter((employee) => {
  //       const depMatch = employee.department_name
  //         .toLowerCase()
  //         .includes(lowercaseSelectedName);
  //       // const rhMatch = employee.rh_name.toLowerCase().includes(lowercaseSelectedName);
  //       const rhMatch = employee.rh_name
  //         ? employee.rh_name.toLowerCase().includes(lowercaseSelectedName)
  //         : false;
  //       return depMatch || rhMatch;
  //     });
  //   }

  //   setFilteredEmployee(filteredData);
  // };

  // useEffect(() => {
  //   applyFilters();
  // }, [
  //   selectedName,
  //   selectedStatus,
  //   selectedDep,
  //   allattendance,
  // ]);


  // Remove your existing applyFilters and useEffect for filtering, and replace with this:

  const filteredAndSortedEmployees = useMemo(() => {
    let filteredData = allattendance;

    // 1. Apply Filters
    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.name.toLowerCase().includes(lowercaseSelectedName);
        const empCodeMatch = employee.emp_code.toString().includes(selectedName);
        return nameMatch || empCodeMatch;
      });
    }

    if (selectedDep) {
      const lowercaseSelectedDep = selectedDep.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const depMatch = employee.department_name.toLowerCase().includes(lowercaseSelectedDep);
        const rhMatch = employee.rh_name ? employee.rh_name.toLowerCase().includes(lowercaseSelectedDep) : false;
        return depMatch || rhMatch;
      });
    }

    // 2. Sort the data ONCE
    filteredData = filteredData.sort((a, b) => a.emp_code - b.emp_code);

    // 3. Pre-process attendances into a lookup object for instant rendering
    return filteredData.map(emp => {
      const attendanceMap = {};
      emp.attendances.forEach(att => {
        attendanceMap[att.date] = att; // Keys are "YYYY-MM-DD"
      });
      return { ...emp, attendanceMap };
    });

  }, [allattendance, selectedName, selectedDep]); // Only re-runs if these change

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  // Add state for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 50; // Only render 50 employees at a time

  const [isExporting, setIsExporting] = useState(false);
  const hiddenDownloadBtnRef = useRef(null);

  // Calculate which rows to show
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredAndSortedEmployees.slice(indexOfFirstRow, indexOfLastRow);

  const tableRef = useRef(null);

  const handleDownloadAll = () => {
    setIsExporting(true); // Temporarily show ALL rows in the DOM
    
    // Give React 500ms to paint the full table to the DOM, then export
    setTimeout(() => {
      if (hiddenDownloadBtnRef.current) {
        hiddenDownloadBtnRef.current.click(); // Trigger the library export
      }
      setIsExporting(false); // Immediately restore pagination to stop lag
    }, 500); 
  };

  const displayedRows = isExporting ? filteredAndSortedEmployees : currentRows;

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">

          <div className="field-cont">

            <div className="field-cont-div">
              <Calender />
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split('-');
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ''));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Name or Code"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Dep or Rep Head"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            {SUPER_ADMIN && <div className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={toggleCompany}
                onChange={(e) => setToggleCompany(e.target.value)}
              >
                <option value="null">SubCompany</option>
                {SUB_COMPANIES.sort((a, b) => a.title - b.title).map((i, index) => (
                  <option value={i.id}>{i.title}</option>
                ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>}
          </div>
          {/* <div className="btn-cont">
              </div> */}
          <div className="btn-cont">
            {/* <button className='attendance-btn' onClick={handleSearch}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 11 12" fill="none">
                <circle cx="5" cy="5" r="4.3" stroke="#FFFFFF" stroke-width="1.4" />
                <line x1="10.0101" y1="11" x2="8" y2="8.98995" stroke="#FFFFFF" stroke-width="1.4" stroke-linecap="round" />
              </svg>Search</button> */}
            {/* <DownloadTableExcel
              // filename={
              //   selectedDivision === ""
              //     ? `${monthName}-AttendanceSheet`
              //     : `${monthName}-AttendanceSheet-${selectedDivision}`
              // }
              sheet="users"
              currentTableRef={tableRef.current}
            >
              <button className=" model-button-print">
                <DownloadIcon />
              </button>
            </DownloadTableExcel> */}

              {/* 1. THE VISIBLE BUTTON THE USER CLICKS */}
              <button 
                className="model-button-print" 
                onClick={handleDownloadAll}
                disabled={isExporting}
              >
                <DownloadIcon /> 
                {isExporting && <span style={{ marginLeft: "5px", fontSize: "12px" }}>Wait...</span>}
              </button>

              {/* 2. THE HIDDEN LIBRARY COMPONENT */}
              <div style={{ display: "none" }}>
                <DownloadTableExcel
                  filename={`${monthName}-AttendanceSheet`}
                  sheet="users"
                  currentTableRef={tableRef.current}
                >
                  <button ref={hiddenDownloadBtnRef}>Hidden Download</button>
                </DownloadTableExcel>
              </div>
          </div>
        </div>
      </div >
      <div className="custom-table-width">
        {/* <div className="global-whitebg-table "> */}
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">
            {/* Attendance ( {filteredEmployee.length} of {allattendance.length}) */}
            Attendance ({filteredAndSortedEmployees.length} of {allattendance.length})
            {payrollStartDate && payrollEndDate && (
              <span style={{ fontSize: "12px", fontWeight: 400, marginLeft: "10px", color: "#555" }}>
                {formatDate(payrollStartDate)} → {formatDate(payrollEndDate)}
              </span>
            )}
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="loading"><g><path fill="#414042" d="M29.89 15.81a2.51 2.51 0 1 0-5 .45 9.65 9.65 0 0 1-1.68 6.34 10.24 10.24 0 0 1-5.74 4 10.71 10.71 0 0 1-7.38-.7 11.44 11.44 0 0 1-5.48-5.62A12.07 12.07 0 0 0 9.46 27 12.58 12.58 0 0 0 17.9 29a13.31 13.31 0 0 0 8.18-4 14 14 0 0 0 3.81-8.75v-.08A2.29 2.29 0 0 0 29.89 15.81zM7.11 15.74A9.65 9.65 0 0 1 8.79 9.4a10.24 10.24 0 0 1 5.74-4 10.71 10.71 0 0 1 7.38.7 11.44 11.44 0 0 1 5.48 5.62A12.07 12.07 0 0 0 22.54 5 12.58 12.58 0 0 0 14.1 3 13.31 13.31 0 0 0 5.92 7a14 14 0 0 0-3.81 8.75v.08a2.29 2.29 0 0 0 0 .37 2.51 2.51 0 1 0 5-.45z"></path></g></svg> */}
          </div>

          {buffer || subbuffer ?
            <div className="spinner-vsmall"></div> :
            <div
              className="refresh-button"
              onClick={refreshdata}
              disabled={buffer} //buffering logic
            >
              <Refresh />
            </div>}
        </div>
        <div className="scrollfix-wrapper">
          <table
            ref={tableRef}
            id="my-table"
            style={{
              borderColor: "#323232",
              borderRadius: "5px",
              padding: "0px 5px",
              borderWidth: "1px",
              marginLeft: "10px",
              zoom: "50%",
            }}
            className="scroll-fix-table"
          >
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                borderColor: "#323232",
                borderRadius: "5px",
                padding: "0px 5px",
                borderWidth: "1px",
                marginLeft: "10px",
              }}
            >
              <tr>
                <th className="summary-excel-tab br-5">Emp</th>
                <th className="summary-excel-tab br-5">Name</th>
                <th className="summary-excel-tab br-5">Joining Date</th>
                {/* {datees.map((date) => (
                  <th className="summary-excel-tab br-5" key={date.date}>
                    {date.date}
                  </th>
                ))} */}

                {datees.map((dateObj, idx) => {
                  const prevDateObj = datees[idx - 1];
                  const showMonthLabel = idx === 0 || dateObj.month !== prevDateObj?.month;
                  return (
                    // <th className="summary-excel-tab br-5" key={dateObj.fullDate}>
                    <th
                      className="summary-excel-tab br-5"
                      key={dateObj.fullDate}
                      style={dateObj.isDisabled ? {
                        backgroundColor: "#f0f0f0",
                        color: "#3f3d3d",
                        opacity: 0.9
                      } : {}}
                    >
                      {dateObj.date}
                      {showMonthLabel && (
                        // <div style={{ fontSize: "8px", color: "#888", lineHeight: 1 }}>
                        //   {dateObj.month}
                        // </div>
                        <div style={{ fontSize: "8px", color: dateObj.isDisabled ? "#ccc" : "#888", lineHeight: 1 }}>
                          {dateObj.month}
                        </div>
                      )}
                    </th>
                  );
                })}
                <th className="summary-excel-tab br-5">LB</th>
                <th className="summary-excel-tab br-5">P</th>
                <th className="summary-excel-tab br-5">OT</th>
                <th className="summary-excel-tab br-5">Late</th>
                <th className="summary-excel-tab br-5">RLM</th>
                <th className="summary-excel-tab br-5">HD</th>
                <th className="summary-excel-tab br-5">WOP</th>
                <th className="summary-excel-tab br-5">OD</th>
                <th className="summary-excel-tab br-5">A</th>
                <th className="summary-excel-tab br-5">HOL</th>
                <th className="summary-excel-tab br-5">WO</th>
                <th className="summary-excel-tab br-5">L</th>
                <th className="summary-excel-tab br-5">HDL</th>
                <th className="summary-excel-tab br-5">SDL</th>
                <th className="summary-excel-tab br-5">WFH</th>
                <th className="summary-excel-tab br-5">HDOD</th>
                <th className="summary-excel-tab br-5">SDOD</th>
                <th className="summary-excel-tab br-5">UL</th>
                <th className="summary-excel-tab br-5">HDUL</th>
                <th className="summary-excel-tab br-5">SDUL</th>
                <th className="summary-excel-tab br-5">Miss</th>
                <th className="summary-excel-tab br-5">Paid Days</th>
              </tr>
            </thead>

            {
              // buffer ? <div className="spinner"></div> :
              // <tbody>
              //   {filteredEmployee
              //     .sort((a, b) => a.emp_code - b.emp_code)
              //     .map((data, index) => {
              //       const background = data.late === 0 ? "white" : "#f9935f";

              //       const inactivename =
              //         data.employee_status === "inactive" ? "#ff1212" : "black";
              //       const present = data.present === 0 ? "white" : "#a3fc92";
              //       const ontime = data.ontime === 0 ? "white" : "#a3fc92";
              //       const late = data.late === 0 ? "white" : "#ffea72";
              //       const rlm = data.rlm === 0 ? "white" : "#a3fc92";
              //       const halfday = data.halfday === 0 ? "white" : "#ffea72";
              //       const wop = data.wop === 0 ? "white" : "#a3fc92";
              //       const od = data.outduty === 0 ? "white" : "#73DBDBCC";
              //       const bgabsent = data.absent === 0 ? "white" : "#fccab1";
              //       const holiday = data.holiday === 0 ? "white" : "#83B8E6CC";
              //       const weeklyoff = data.weeklyoff === 0 ? "white" : "#83B8E6CC";
              //       const leave = data.leave === 0 ? "white" : "#a3fc92";
              //       const halfdayleave =
              //         data.halfdayleave === 0 ? "white" : "#a3fc92";
              //       const shortleave = data.shortleave === 0 ? "white" : "#a3fc92";

              //       const workfromhome =
              //         data.workfromhome === 0 ? "white" : "#a3fc92";
              //       const hdoutduty = data.hdoutduty === 0 ? "white" : "#73DBDBCC";
              //       const shortoutduty =
              //         data.shortoutduty === 0 ? "white" : "#73DBDBCC";
              //       const unpaidleave =
              //         data.unpaidleave === 0 ? "white" : "#fccab1";
              //       const unpaidleavehd =
              //         data.unpaidleavehd === 0 ? "white" : "#fccab1";
              //       const unpaidshortleave =
              //         data.unpaidshortleave === 0 ? "white" : "#fccab1";
              //       const misspunch = data.misspunch === 0 ? "white" : "#fccab1";

              //       const bgtotalpaiddays = data.total === dates.length ? "white" : "#fccab1";

              //       const hd = data.halfday === 0 ? "white" : "#fccab1";

              //       return (
              //         <>
              //           <tr
              //             style={{
              //               backgroundColor:
              //                 index === selectedIndex ? "yellow" : "white",
              //               color: inactivename,
              //             }}
              //             onClick={() => handleClick(index)}
              //           >
              //             <td className="summary-excel-tab br-5">{data.emp_code}</td>
              //             <td className="summary-excel-tab br-5">{data.name}</td>
              //             <td className="summary-excel-tab br-5" title={data.last_working_date ? `Last Working Date - ${formatDate(data.last_working_date)}` : ''}>{formatDate(data.joining_date)}</td>
              //             {dates.map((dateObj) => {
              //               const attendanceForDate = data.attendances.find(
              //                 (attendance) => attendance.date === dateObj.date  // ✅ "YYYY-MM-DD" match
              //               );
              //               const attendanceStatus = attendanceForDate
              //                 ? attendanceForDate.day_status
              //                 : "-";

              //               const attendanceStatuss = attendanceForDate
              //                 ? attendanceForDate.day_status === "ontime"
              //                   ? "P"
              //                   : attendanceForDate.day_status === "outduty"
              //                     ? "OD"
              //                     : attendanceForDate.day_status === "halfday"
              //                       ? "HD"
              //                       : attendanceForDate.day_status === "paidleave"
              //                         ? "PL"
              //                         : attendanceForDate.day_status === "late"
              //                           ? "Late"
              //                           : attendanceForDate.day_status === "weeklyoff"
              //                             ? "WO"
              //                             : attendanceForDate.day_status === "wop"
              //                               ? "WOP"
              //                               : attendanceForDate.day_status === "rlm"
              //                                 ? "RLM"
              //                                 : attendanceForDate.day_status === "halfdayleave"
              //                                   ? "HDL"
              //                                   : attendanceForDate.day_status ===
              //                                     "paidhalfdayleave"
              //                                     ? "PHDL"
              //                                     : attendanceForDate.day_status === "unpaidleave"
              //                                       ? "UL"
              //                                       : attendanceForDate.day_status === "shortleave"
              //                                         ? "SL"
              //                                         : attendanceForDate.day_status ===
              //                                           "unpaidshortleave"
              //                                           ? "USL"
              //                                           : attendanceForDate.day_status === "unpaidleavehd"
              //                                             ? "UHD"
              //                                             : attendanceForDate.day_status === "hdoutduty"
              //                                               ? "HOD"
              //                                               : attendanceForDate.day_status === "shortoutduty"
              //                                                 ? "SOD"
              //                                                 : attendanceForDate.day_status === "misspunch"
              //                                                   ? "Miss"
              //                                                   : attendanceForDate.day_status === "holiday"
              //                                                     ? "Hol"
              //                                                     : attendanceForDate.day_status === "absent"
              //                                                       ? "A"
              //                                                       : attendanceForDate.day_status.slice(0, 2)
              //                 : "-";

              //               const today = dateObj.date;
              //               const inTime = attendanceForDate
              //                 ? attendanceForDate.in_time
              //                 : "-";
              //               const outTime = attendanceForDate
              //                 ? attendanceForDate.out_time
              //                 : "-";
              //               const attstat = attendanceForDate
              //                 ? attendanceForDate.attendence_status
              //                 : "-";
              //               const daystatus = attendanceForDate
              //                 ? attendanceForDate.day_status
              //                 : "-";
              //               const duration = attendanceForDate
              //                 ? attendanceForDate.work_duration
              //                 : "-";

              //               return (
              //                 // <>
              //                 // <td
              //                 //   style={{
              //                 //     backgroundColor:
              //                 //       index === selectedIndex ? "yellow" : "",
              //                 //     color: index === selectedIndex ? "black" : "",
              //                 //   }}
              //                 //   data-status={
              //                 //     (date.date >= data.joining_date && (!data.last_working_date || date.date <= data.last_working_date))
              //                 //       // (!data.last_working_date || date.date <= data.last_working_date)
              //                 //       ? attendanceStatus
              //                 //       : "-"}
              //                 //   className="behavior summary-excel-tab"
              //                 //   title={`Date: ${formattedDateLong(
              //                 //     today
              //                 //   )}\nIn Time: ${inTime}\nOut Time: ${outTime}\nDay Status: ${daystatus}\nAttendance Status: ${attstat}\nWork Duration: ${duration}`}
              //                 // >
              //                 //   {
              //                 //     (date.date >= data.joining_date && (!data.last_working_date || date.date <= data.last_working_date))
              //                 //       // (!data.last_working_date || date.date <= data.last_working_date)
              //                 //       ? attendanceStatuss
              //                 //       : "-"
              //                 //   }
              //                 // </td>
              //                 <td
              //                   style={{
              //                     backgroundColor: index === selectedIndex
              //                       ? "yellow"
              //                       : dateObj.isDisabled
              //                         ? "#f0f0f0"
              //                         : "",
              //                     color: index === selectedIndex
              //                       ? "black"
              //                       : dateObj.isDisabled
              //                         ? "#3f3d3d"
              //                         : "",
              //                     opacity: dateObj.isDisabled ? 0.9 : 1,
              //                     position: 'relative',
              //                   }}
              //                   data-status={
              //                     (dateObj.date >= data.joining_date &&
              //                       (!data.last_working_date || dateObj.date <= data.last_working_date))
              //                       ? attendanceStatus
              //                       : "-"
              //                   }
              //                   className="behavior summary-excel-tab"
              //                 >
              //                   {/* // <td
              //                 //   style={{
              //                 //     backgroundColor: index === selectedIndex ? "yellow" : "",
              //                 //     color: index === selectedIndex ? "black" : "",
              //                 //     position: 'relative',
              //                 //   }}
                               
              //                 //   data-status={
              //                 //     (dateObj.date >= data.joining_date &&
              //                 //       (!data.last_working_date || dateObj.date <= data.last_working_date))
              //                 //       ? attendanceStatus
              //                 //       : "-"
              //                 //   }
              //                 //   className="behavior summary-excel-tab"
              //                 // > */}

              //                   <CustomTooltip
              //                     position="top"
              //                     tooltipContent={
              //                       <div>
              //                         Date: {formattedDateLong(dateObj.date)}
              //                         <br />
              //                         In Time: {inTime}
              //                         <br />
              //                         Out Time: {outTime}
              //                         <br />
              //                         Day Status: {daystatus}
              //                         <br />
              //                         Attendance Status: {attstat}
              //                         <br />
              //                         Work Duration: {duration}
              //                         {(attendanceForDate?.regularization_logs?.length > 0) &&
              //                           // <div className='horizontal-divider white'></div>
              //                           <div
              //                             style={{
              //                               borderBottom: "1px solid #eee",
              //                             }}
              //                           >
              //                           </div>
              //                         }
              //                         {attendanceForDate?.regularization_logs?.length > 0 &&
              //                           <>
              //                             Regularization Reason:
              //                             <br />
              //                             -{[...attendanceForDate.regularization_logs]
              //                               .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0]
              //                               .reason
              //                             }
              //                           </>
              //                         }
              //                         {attendanceForDate?.arrear_details &&
              //                           // <div className='horizontal-divider white'></div>
              //                           <div
              //                             style={{
              //                               borderBottom: "1px solid #eee",
              //                             }}
              //                           >
              //                           </div>
              //                         }
              //                         {attendanceForDate?.arrear_details?.length === 1 &&
              //                           <>
              //                             This date Arreared in {attendanceForDate?.arrear_details[0].applicable_period}
              //                           </>
              //                         }
              //                         {attendanceForDate?.arrear_details?.length > 1 &&
              //                           <>
              //                             This date used in multiple Arrears
              //                           </>
              //                         }
              //                       </div>
              //                     }
              //                   >
              //                     {/* {
              //                       (date.date >= data.joining_date && (!data.last_working_date || date.date <= data.last_working_date))
              //                         ? attendanceStatuss
              //                         : "-"
              //                     } */}
              //                     {
              //                       (dateObj.date >= data.joining_date &&
              //                         (!data.last_working_date || dateObj.date <= data.last_working_date))
              //                         ? attendanceStatuss
              //                         : "-"
              //                     }
              //                   </CustomTooltip>
              //                   {(attendanceForDate?.regularization_logs?.length > 0 || attendanceForDate?.arrear_details) && (
              //                     <span
              //                       style={{
              //                         position: 'absolute',
              //                         top: 2,
              //                         right: 2,
              //                         fontSize: '5px',
              //                         color: 'white',
              //                         width: '6px',
              //                         height: '6px',
              //                         borderRadius: '100%',
              //                         backgroundColor: '#2576BC',
              //                         cursor: 'pointer',
              //                         textAlign: 'center'
              //                       }}
              //                       title="This Attendance has Extra Details like Regularization, Arrear Usage etc."
              //                       className="font-weight600"
              //                     >
              //                       i
              //                     </span>
              //                   )}
              //                 </td>


              //               );
              //             })}
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: "" }}
              //             >
              //               <CustomTooltip
              //                 position="top"
              //                 tooltipContent={
              //                   <div>
              //                     Previous: {data?.leavebalance}
              //                     <br />
              //                     Casual: {data?.casual_leave}
              //                     <br />
              //                     Sick: {data?.sick_leave}
              //                     <br />
              //                     Earn: {data?.earn_leave}
              //                     <br />
              //                     Short: {data?.short_leave}
              //                   </div>
              //                 }
              //               >
              //                 {
              //                   data?.leavebalance +
              //                   data?.casual_leave +
              //                   data?.sick_leave +
              //                   data?.earn_leave 
              //                   // + data?.short_leave
              //                 }
              //               </CustomTooltip>
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: present }}
              //             >
              //               {data.present}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: ontime }}
              //             >
              //               {data.ontime}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: late }}
              //             >
              //               {data.late}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: rlm }}
              //             >
              //               {data.rlm}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: halfday }}
              //             >
              //               {data.halfday}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: wop }}
              //             >
              //               {data.wop}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: od }}
              //             >
              //               {data.outduty}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: bgabsent }}
              //             >
              //               {data.absent}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: holiday }}
              //             >
              //               {data.holiday}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: weeklyoff }}
              //             >
              //               {data.weeklyoff}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: leave }}
              //             >
              //               {data.leave}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: halfdayleave }}
              //             >
              //               {data.halfdayleave}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: shortleave }}
              //             >
              //               {data.shortleave}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: workfromhome }}
              //             >
              //               {data.workfromhome}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: hdoutduty }}
              //             >
              //               {data.hdoutduty}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: shortoutduty }}
              //             >
              //               {data.shortoutduty}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: unpaidleave }}
              //             >
              //               {data.unpaidleave}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: unpaidleavehd }}
              //             >
              //               {data.unpaidleavehd}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: unpaidshortleave }}
              //             >
              //               {data.unpaidshortleave}
              //             </td>
              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: misspunch }}
              //             >
              //               {data.misspunch}
              //             </td>

              //             <td
              //               className="summary-excel-tab br-5"
              //               style={{ backgroundColor: bgtotalpaiddays }}
              //             >
              //               {data.total}
              //             </td>
              //           </tr>
              //         </>
              //       );
              //     })}
              // </tbody>

              <tbody>
                {displayedRows.map((data, index) => {
                  // Because we sliced the array, we need to calculate the TRUE index for highlighting
                  const trueIndex = indexOfFirstRow + index;
                  
                  return (
                      <EmployeeRow 
                        key={data.emp_code} 
                        data={data}
                        dates={dates}
                        index={trueIndex}
                        isSelected={trueIndex === selectedIndex}
                        onClick={handleClick}
                        formatDate={formatDate}
                        formattedDateLong={formattedDateLong}
                      />
                  )
                })}
              </tbody>
            }
          </table>

          <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
            <button 
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>Page {currentPage} of {Math.ceil(filteredAndSortedEmployees.length / rowsPerPage)}</span>
            <button 
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredAndSortedEmployees.length / rowsPerPage)))}
              disabled={currentPage === Math.ceil(filteredAndSortedEmployees.length / rowsPerPage)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const Attendance = () => {
  const [toggleState, setToggleState] = useState(1);

  return (
    <div>
      <div>
        <div>
          <div className="bloc-tabs-with-white-bg">
            <button
              className={
                toggleState === 1
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(1)}
            >
              Daily Attendance
            </button>
            <button
              className={
                toggleState === 2
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(2)}
            >
              Employee Attendance
            </button>
            {/* <button
              className={
                toggleState === 3
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(3)}
            >
              Summary Sheet
            </button> */}
            <button
              className={
                toggleState === 4
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(4)}
            >
              Monthly Summary Sheet
            </button>
          </div>
        </div>

        <div className="content-tabs-without-margin">
          {toggleState === 1 ? <DailyAttendance /> : null}

          {toggleState === 2 ? <EmployeeAttendance /> : null}

          {toggleState === 3 ? <SummarySheet /> : null}

          {toggleState === 4 ? <SummarySheetExcel /> : null}
        </div>
      </div>
    </div>
  );
};

export default Attendance;
